import { Region } from '@classifieds-sell/datalayer';
import { isNullOrWhiteSpace } from '@classifieds-sell/shared';

export const INVALID_STREET_NAME_ERROR_MESSAGE =
    'A street name is required if a street number is added';
export const INVALID_STREET_NAME_OR_NUMBER_ERROR_MESSAGE =
    'A street name and number are required if a unit / flat is added';
export const validateNoStreetNameAddedWithNumber = (
    streetName: string,
    streetNumber: string
): boolean => {
    return streetNumber && isNullOrWhiteSpace(streetName);
};

export const validateNoStreetNameOrNumberWithUnitFlat = (
    streetName: string,
    streetNumber: string,
    unitFlat: string
): boolean => {
    return unitFlat && (isNullOrWhiteSpace(streetName) || isNullOrWhiteSpace(streetNumber));
};

export const getFullAddress = (
    propertyInformation: any,
    regions: Region[]
): string => {
    const region = regions.find(
        (f) => f.regionId === propertyInformation.regionId
    );

    const district = region.districts.find(
        (f) => f.districtId === propertyInformation.districtId
    );

    const suburb = district.suburbs.find(
        (f) => f.suburbId === propertyInformation.suburbId
    );

    let streetInfo = '';

    if (!isNullOrWhiteSpace(propertyInformation.unitFlat)) {
        streetInfo = propertyInformation.unitFlat;
    }

    if (!isNullOrWhiteSpace(propertyInformation.streetNumber)) {
        if (!isNullOrWhiteSpace(propertyInformation.unitFlat)) {
            streetInfo += '/' + propertyInformation.streetNumber;
        } else {
            streetInfo = propertyInformation.streetNumber;
        }
    }

    if (!isNullOrWhiteSpace(propertyInformation.streetName)) {
        if (!isNullOrWhiteSpace(streetInfo)) {
            streetInfo += ' ' + propertyInformation.streetName;
        } else {
            streetInfo = propertyInformation.streetName;
        }
    }

    const addressParts = [
        streetInfo,
        suburb?.name,
        district?.name,
        region?.name
    ];

    return addressParts.reduce(
        (pre, cur) => pre + `${pre ? ', ' : ''}${cur}`,
        ''
    );
};
